import React from "react";
import {
  FaNetworkWired,
  FaLock,
  FaRegSmile,
  FaExchangeAlt,
  FaSyncAlt,
  FaGlobe,
  FaCogs,
  FaImage,
  FaCube,
  FaDatabase,
} from "react-icons/fa";

function SecureStorage() {
  return (
    <>
      <div className="team-single-area default-padding">
        <div className="container">
          <div className="team-single-items">
            <div className="row">
              <div className="col-lg-5 left-info">
                <div className="thumb fade-up-anim">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/team/5.jpg"
                    alt="Thumb"
                  />
                </div>
              </div>
              <div className="col-lg-7 right-info pl-30 pl-md-15 pl-xs-15">
                <div className="container">
                  <div className=" col-lg-12">
                    <div className="site-heading">
                      <h4 className="sub-title">Our Services</h4>
                      <h2 className="title split-text-right split-text-in-right split-lines">
                        AI-optimized design for innovative futures
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className="">
                    <div className="container">
                      <div className="services-style-four-items">
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaNetworkWired size={35} />
                          </div>
                          <h4>Multi-Blockchain Support</h4>
                          <p>
                            Ability to handle NFTs across multiple blockchain
                            networks like Ethereum, Solana, Binance Smart Chain,
                            Polygon, and others, offering versatility for users.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaLock size={35} />
                          </div>
                          <h4>Secure Storage</h4>
                          <p>
                            High-level security features such as encrypted
                            private keys, biometric authentication, and
                            multi-signature support to safeguard NFTs from
                            unauthorized access.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaRegSmile size={35} />
                          </div>
                          <h4>User-Friendly Interface</h4>
                          <p>
                            A simple and intuitive UI/UX that allows users to
                            easily view, store, transfer, and manage their NFT
                            collections without technical complications.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaExchangeAlt size={35} />
                          </div>
                          <h4>Seamless NFT Transactions</h4>
                          <p>
                            Enable users to send and receive NFTs effortlessly
                            with low transaction fees and fast confirmation
                            times across supported blockchains.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaGlobe size={35} />
                          </div>
                          <h4>Cross-Device Synchronization</h4>
                          <p>
                            Users can access their NFT wallet from multiple
                            devices, ensuring convenience without compromising
                            security.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaGlobe size={35} />
                          </div>
                          <h4>Integrated Marketplace Access</h4>
                          <p>
                            Direct integration with NFT marketplaces, allowing
                            users to buy, sell, or auction NFTs directly within
                            the wallet interface.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaCogs size={35} />
                          </div>
                          <h4>Customizable Wallet Features</h4>
                          <p>
                            Support for custom features like gas fee management,
                            transaction history, and token swaps within the
                            wallet.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaImage size={35} />
                          </div>
                          <h4>NFT Display & Metadata Viewing</h4>
                          <p>
                            Visual representation of owned NFTs, including
                            detailed metadata, properties, and provenance
                            information to enhance user experience.
                          </p>
                        </div>
                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaCube size={35} />
                          </div>
                          <h4>Multi-Asset Support</h4>
                          <p>
                            Beyond NFTs, the wallet can also store other digital
                            assets like cryptocurrencies, making it a
                            comprehensive solution for managing both fungible
                            and non-fungible tokens.
                          </p>
                        </div>

                        <div className="services-style-four-item">
                          <div className="icon">
                            <FaDatabase size={35} />
                          </div>
                          <h4>Backup & Recovery Options</h4>
                          <p>
                            Secure backup and recovery options, such as mnemonic
                            phrases or hardware wallet integration, to prevent
                            loss of access to the wallet.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SecureStorage;
